import { motion } from 'framer-motion';
import { projects } from '../constants';
import ProjectCard from './ProjectCard';

const Projects = ({ handleOpenModal }) => {
    return (
        <section id="projects" className="section">
            <div className="container">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="mb-16"
                >
                    <div className="flex items-center gap-4 mb-4">
                        <span className="w-12 h-[1px] bg-primary-purple"></span>
                        <span className="text-primary-purple uppercase tracking-widest text-sm font-medium">Selected Works</span>
                    </div>
                    <h2 className="text-4xl md:text-5xl font-bold">Featured Projects</h2>
                </motion.div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {projects.map((project, index) => (
                        <ProjectCard
                            key={project.title}
                            project={project}
                            index={index}
                            handleOpenModal={handleOpenModal}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Projects;
